import { Logger } from '@chr/common-javascript-logging-core';
import { createElement, Fragment, Component } from 'react';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

/**
 * A React component implementing componentDidCatch; see
 * https://reactjs.org/docs/react-component.html#componentdidcatch
 * for more info.
 *
 * Example usage:
 * <LoggingErrorBoundary>
 *  <MyPotentiallyDangerousComponent />
 *  <SomethingThatWillNeverBreakBecauseImReallyGoodAtMyJob />
 *  <AnotherFragileComponentThatSomeoneElseWhosNotMeWroteBeforeMyTime />
 * </LoggingErrorBoundary>
 *
 * If any of the child components throw, all will be unmounted and an error
 * message will display instead. The error details will be placed inside
 * a hidden div for ease of troubleshooting.
 *
 * Pro tip: have an error boundary at the root of your app, otherwise the
 * entire app will be unmounted and the user will be terribly confused.
 */
var LoggingErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(LoggingErrorBoundary, _React$Component);

  var _super = _createSuper(LoggingErrorBoundary);

  function LoggingErrorBoundary(props) {
    var _this;

    _classCallCheck(this, LoggingErrorBoundary);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      error: null,
      errorInfo: null
    });

    _this.resetError = _this.resetError.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(LoggingErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      try {
        Logger.logError(error, {
          errorInfo: errorInfo
        });
      } catch (e) {
        console.log(e);
      }

      this.setState(function () {
        return {
          error: error,
          errorInfo: errorInfo
        };
      });
    }
  }, {
    key: "resetError",
    value: function resetError() {
      this.setState({
        error: null,
        errorInfo: null
      });
    }
  }, {
    key: "render",
    value: function render() {
      return !this.state.error ? this.props.children : this.props.render ? this.props.render(this.state.error, this.state.errorInfo, this.resetError) : /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
        className: "alert alert-danger"
      }, "An error occurred and has been logged."), /*#__PURE__*/createElement("div", {
        style: {
          display: 'none'
        }
      }, /*#__PURE__*/createElement("h5", null, "Error:"), JSON.stringify(this.state.error), /*#__PURE__*/createElement("h5", null, "Error info:"), JSON.stringify(this.state.errorInfo)));
    }
  }]);

  return LoggingErrorBoundary;
}(Component);

export { LoggingErrorBoundary };
